import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import querystring from 'querystring';

import {CONTACT_EMAIL} from 'app/const';

import styles from './index.module.scss';


function Button({tagName, className, theme, size, ...props}) {
    const TagName = tagName;
    props.className = classNames(
        styles.button,
        styles[`button--theme-${theme}`],
        styles[`button--size-${size}`],
        className,
    );
    return <TagName {...props} />;
}


Button.propTypes = {
    theme: PropTypes.oneOf(['default', 'accent']).isRequired,
    size: PropTypes.oneOf(['default', 'large']).isRequired,
};


Button.defaultProps = {
    theme: 'default',
    size: 'default',
};


export function LinkButton({...props}) {
    return <Button {...props} />;
}

LinkButton.defaultProps = {
    tagName: Link,
};


export function AnchorButton({...props}) {
    return <Button {...props} />;
}

AnchorButton.defaultProps = {
    tagName: 'a',
};


export function ContactButton({emailSubject, emailBody, ...props}) {

    const _query = querystring.stringify({
        subject: emailSubject,
        body: emailBody,
    });

    props.href = `mailto:${CONTACT_EMAIL}?${_query}`;

    // Open Webmail page in another tab. Should have no effect when
    // opening a traditional mail client.
    props.target = '_blank';

    return <AnchorButton {...props} />;
}



// WEBPACK FOOTER //
// ./src/ui/button/index.js